import { ROUTES } from "./routes";

export const hoursePowerMapping: any = {
  LESS_40: "Less then 40",
  BETWEEN_40_99: "40-99",
  BETWEEN_100_175: "100-175",
  BETWEEN_176_299: "176-299",
  ABOVE_300: "300 and above",
  1: {
    hp_from: 0,
    hp_to: 25,
  },
  2: {
    hp_from: 26,
    hp_to: 50,
  },
  3: {
    hp_from: 51,
    hp_to: 99,
  },
  4: {
    hp_from: 100,
    hp_to: 200,
  },
  5: {
    hp_from: 200,
    hp_to: 299,
  },
  6: {
    hp_from: 300,
    hp_to: 999999999,
  },
};

export const attachmentCapacityUnits = {
  LBS: "lbs",
  FEETS: "feets",
  YDS: "yds",
};

export const pricingRateTypes: any = {
  1: "per day",
};
export const pricingRateTypesDisplay: any = {
  1: "Day",
};
export const pricingRateTypesMapping: any = {
  PER_DAY: "PER_DAY",
  PER_HOUR: "PER_HOUR",
};

export const TRACTOR_STATUS = {
  UNDER_REVIEW: "Under Review",
  APPROVED: "Approved",
};

export const TRACTOR_STATUS_MAPPING = {
  UNDER_REVIEW: "UNDER_REVIEW",
  APPROVED: "APPROVED",
};

export const ATTACHMENT_STATUS = {
  DRAFT: "Draft",
  UNDER_REVIEW: "Under Review",
  APPROVED: "Approved",
};

export const ATTACHMENT_STATUS_MAPPING = {
  DRAFT: "DRAFT",
  UNDER_REVIEW: "UNDER_REVIEW",
  APPROVED: "APPROVED",
};

export const attachmentTypes: any = {
  "3PTGRAG": "3PT Drag",
  "3PTPTO": "3PT PTO",
};

export const dashboardOptions = [
  {
    label: "Dashboard",
    icon: "dashboard-icon.png",
    link: ROUTES.DASHBOARD,
  },
  {
    label: "Rentals",
    icon: "dashboard-icon.png",
    link: ROUTES.RENTALS,
  },
  {
    label: "Listings",
    icon: "dashboard-icon.png",
    link: ROUTES.MANAGE_LISTING,
  },
  // {
  //   label: 'Calendar',
  //   icon: '',
  //   link: ROUTES.VIEW_BOOKING,
  // },
  {
    label: "Communication",
    icon: "communication.png",
    link: ROUTES.MESSAGES.replace(":id", ""),
  },
  {
    label: "Document",
    icon: "communication.png",
    link: ROUTES.DOCUMENTS,
  },
];

export const faqGeneral = [
  {
    title: "How do I create an account?",
    desc: "It’s easy. Click on the Login button on the top right of the home page and create your account. Or simply use your Facebook, google or Apple account to log in. ",
  },
  {
    title: "How do I change my password and account information?",
    desc: "To update your name and other information, click on My Profile >> Edit Profile>> Change Password",
  },
  {
    title: "Do I need to upload profile picture?  Is it a rule?",
    desc: "It is not mandatory but is recommended. A description about you would give an idea to the renter / owner to learn more about you before booking or renting your equipment. ",
  },
  {
    title: "How secure is Haystackers?",
    desc: "Haystackers is very serious about protecting the privacy of its users. Your personal information will be used in the manner that is mentioned in our privacy policy. By providing information to us when using this website, you agree to this privacy policy. We may occasionally amend our privacy policy to reflect the regulatory requirements. As and when we make changes we seek your acceptance to the amended policies for continued usage of the website or apps. Additionally, the website may contain links to third party sites and we’re not responsible for the privacy and practices or the content of those sites. Please carefully read their policies before giving out your personal information on any third party sites. ",
  },
  {
    title: "Haystackers’s Covid Response",
    descs: [
      "Haystackers takes all the precautions to stop the spread of Covid 19 by going an extra mile on the safety and cleanliness of our EQUIPMENT. Cleanliness is even more critical in these desperate times and we focus on high standards of EQUIPMENT sanitization and disinfection every time you rent so you can feel safe and confident. ",
      "We strictly adhere to CDC guidelines for cleaning and social distancing.   We recommend Owners to have EQUIPMENT thoroughly cleaned between every rental. We want you to feel confident and we will take every opportunity to enhance the health and safety measures we currently practice.",
    ],
  },
  {
    title: "Smoking Policy",
    descs: [
      "While this decision is left at the discretion of the EQUIPMENT owner, Haystackers recommends Renter’s to work with Owners and get an approval to Smoke inside the EQUIPMENT. For more on the rules around smoking in the EQUIPMENT, please check with the owner of the EQUIPMENT before you rent.",
    ],
  },
  {
    title: "Lost and Found",
    descs: [
      "Whether it’s your sunglasses, phone charger, home keys or something more valuable, please contact the owner of the EQUIPMENT as soon as you realize that you left something behind. No stress. It happens to the best of us. Your best chance of recovering your item is within a short window and before the EQUIPMENT is flipped to the next renter. So contact the owner as soon as possible.",
    ],
  },
  {
    title: "Pet Policy",
    descs: [
      "Pets are family and we don’t want you to leave them out of the fun either. However, this decision is at your owner’s discretion. Owners may charge you pet fees though.",
      "For Owner’s:- Welcoming pets into your EQUIPMENT will favorably increase your rental prospects.",
    ],
  },
];

export const faqOwners = [
  {
    title: "How much does it cost to list my EQUIPMENT?",
    desc: "No, listing an EQUIPMENT is absolutely free with Haystackers.",
  },
  {
    title: "How much Commission does Haystackers charge?",
    desc: "Haystackers offers greater service at a lower price. We understand that most of the work is performed by owners and we want to put maximum money in to your pockets. Hence we feel 15% commissions is reasonable. This is applied on Base Rent, Add On fees, Excess usage and other checkout fees claimed by owner.",
  },
  {
    title: "Why should I list my EQUIPMENT with Haystackers?",
    desc: "If you have an EQUIPMENT in a good working condition but idle and if you want to earn some extra cash to cover your expenses or to save for your future you should consider listing your EQUIPMENT with Haystackers. You make the rules for how and when your EQUIPMENT can be used. You can be in control of your pricing, requirements and schedule among other things.   We will handle the rest for you while you can do business at your convenience. ",
  },
  {
    title: "What are the pre-requisites to list an EQUIPMENT?",
    desc: "EQUIPMENT should be in good condition and pass the self-inspection on quarterly basis.",
  },
  {
    title: "How do I list my EQUIPMENT? ",
    desc: "Listing an EQUIPMENT is very simple. After you sign up, you can list your EQUIPMENT on the owner dashboard either using our Website or by using our App. You will need to describe your EQUIPMENT like make, model & year. Upload some pictures of your EQUIPMENT as pictures are the first impression of your EQUIPMENT and it’s better to be perfect.  That’s it. It’s that simple. When someone request to rent your EQUIPMENT, you will be notified.",
  },
  {
    title: "How much can I earn by listing my EQUIPMENT?",
    desc: "Depending on the type of the EQUIPMENT you can earn anywhere between 1000-5000 USD per week. As every equipment/tractor is different and you can bundle your listing with other add-ons like Attachments, implements etc we see an enormous potential for great income on an otherwise Idle equipment. ",
  },
  {
    title: "Can I still enjoy my EQUIPMENT while I list it on your platform?",
    desc: "Yes, owners can continue using their EQUIPMENT and engage in renting as per their availability. To make it easier you can block the dates in the calendar if you plan to use on certain days.",
  },
  {
    title: "What is Instabooking?",
    desc: "Instabooking is a convenient approach that allows renters to book EQUIPMENT and get confirmation immediately. ",
  },
  {
    title: "What is Manual booking?",
    desc: "Manual booking gives you an opportunity to connect with your renter personally and understand their usage and requirements.  Also rental requests need to be personally approved by you in the owner dashboard. I am not sure whether to have instabooking or manual? If you plan to interact and understand your renter then you can opt for Manual approval. If you are too busy to coordinate then you can opt for Instabook option. ",
  },
  {
    title: "What is 90 day inspection requirement?",
    desc: "In the best interest of the owner, renter and the EQUIPMENT we recommend a periodic quarterly inspection check on all amenities, mechanicals, tires of the EQUIPMENT. The inspection report has to be retained with the owner and must be provided in case of any insurance claims. ",
  },
  {
    title: "Do I need to clean and keep the EQUIPMENT Sanitized?",
    desc: "Sanitation is the top priority and vital pledge we can give our customers especially in the light of Coronavirus.  It’s important that the customers understand the measures we take to ensure their safety and health. ",
  },
  {
    title: "Do I need to deliver EQUIPMENT?",
    desc: "Owners can volunteer to deliver EQUIPMENTs and apply the delivery fee as deemed necessary. Delivery of EQUIPMENTs will greatly increase your rental prospects.",
  },
  {
    title: "I am nervous if my EQUIPMENT will be abused for illegal purpose",
    desc: "Renter agreement strictly prohibits abuse of EQUIPMENT or for any illegal purposes.  Haystackers and Owners can take legal action against the renter and the owner can forfeit the security deposit as a first step. ",
  },
  {
    title: "As an owner can I cancel any bookings? ",
    desc: "We understand emergencies can happen and your EQUIPMENT can have a breakdown or is undergoing maintenance issues.  In such scenarios you can cancel the booking anytime with as much notice as possible to your renter so they can make alternate arrangements. However, full refund should be issued to the customer for all the cancellations an owner makes after the reservation has been made and paid. ",
  },
  {
    title: "Where can I see the breakup of payment?",
    desc: "In the owner dashboard click Payments and each payment made will have detailed breakdown.",
  },
  {
    title: "Does Haystackers Charge any Credit Card Transaction fee?",
    desc: "Haystackers deducts 3.5% on all payments made to owner.",
  },
  {
    title:
      "What are the different types of Add-ons and how to create them on listing",
    descs: [
      "Add-ons are the additional options or accessories you are providing your customer for making their usage is stress free. Few of them include",
      "Delivery & Pickup fee",
      "Operator Fee(Owners can volunteer to operate the Equipment for the Renter on an hourly basis. Additional Attachments/Equipments as needed by the Renter.",
      "As an owner you can add as many add-ons you prefer to any new or existing listing.",
      "All of these can also be packaged in a quote and sent to the Renter.",
    ],
  },
  {
    title: "How do I send quotation to a prospective renter",
    desc: "Send quote is the option available on the App and website. Click and select who you want to send quote from recent conversations. You can select all add-ons to be added and send it to the renter for completion.",
  },
  {
    title:
      "My renter is asking me to cancel the reservation? What is the difference between owner cancelations vs renter cancelations?",
    desc: "Cancelation by Owner would mean full refund to renter irrespective of cancellation policy and timelines. Whereas when a renter is cancelling a booking the refund depends on cancelation policy.",
  },
];

export const faqRenters = [
  {
    title: "What is Haystackers? Why should I rent with you?",
    descs: [
      "Haystackers is one of the most affordable and safest peer to peer marketplace for EQUIPMENT rentals across the US. We treat our customers like family and believe in building relations and togetherness.",
      "Renting with us is hassle free and we make the rental process as stress free as possible.  All you need to do is plan your farm project and the rest everything is available at Haystackers.",
    ],
  },
  {
    title: "How to book an EQUIPMENT?",
    desc: "Booking an EQUIPMENT is made very simple. From our catalogue of EQUIPMENTs select the one that’s perfect for you using your location of pickup. After you decide the EQUIPMENT, send your request to owners of the EQUIPMENT with your desired dates of Usage. Your owner will reach out to you after the request is received. Once you both agree, you can make the payment on the platform to confirm the rental.",
  },
  {
    title:
      "As a Renter do I need to pay any fee to use Haystackers to make EQUIPMENT Booking?",
    desc: "Haystackers Charges 5% from Renters for the Base Rent & Add-Ons.",
  },
  {
    title: "What are the minimum age requirements to rent from Haystackers?",
    desc: "The minimum age requirement to rent an EQUIPMENT is 25 years of age or older. The renter should have a valid Driver’s license, and full coverage insurance in his/her name before renting.",
  },
  {
    title: "How do I send rental offer to an owner?",
    desc: "Select your preferred EQUIPMENT and send the offer to rent to the concerned owner and if accepted Booking is confirmed.",
  },
  {
    title: "I have change of plans and need to cancel?",
    desc: " In such scenarios you have 24 hours of “Change of Mind” duration in which Renter’s can cancel with no penalty. This is irrespective of the kind of cancellation policy and when you cancel. As long as you cancel within 24 hours from booking period you will get full refund(Minus Credit card transaction fee) no questions asked.",
  },
  {
    title: "How do I change dates in reservation?",
    desc: "Changing dates of a confirmed booking is only approved if Owner accepts the change. Change request has to be initiated by the renter and to be approved by the owner and vice versa for the changes to take place",
  },
  {
    title: "How do I add new drivers to the reservation?",
    desc: "Besides the primary renter, you can add another driver to the EQUIPMENT and this has to be clearly mentioned in the Departure Form before the EQUIPMENT is picked. The new driver should also have valid driver’s license and must be having insurance on his / her name.",
  },
  {
    title: "Can I return the EQUIPMENT on the weekends?",
    desc: "Absolutely. Based on your dates and your owner’s consent you can return the EQUIPMENT even on weekends?",
  },
  {
    title: "What if I’m unable to return the EQUIPMENT on the planned date?",
    desc: "In such scenarios, communicate with your owner. Renter can do such changes only with Owner’s approval and Renter will be charged for the additional day’s usage based on the rent.",
  },
  {
    title: "How are my refunds processed?",
    desc: "Based on cancellation policy and when the cancellation was done Haystackers will calculate the refund and process it same day.",
  },
  {
    title:
      "I decided to cancel my approved reservation because of change of plans. What is my cancellation policy?",
    desc: "We understand plans change and Haystackers has a fair cancellation policy for both Renters and Owners. If a renter cancels an approved booking, the refund is calculated based on the cancellation policy and cancellation date. However if an Owner cancels a booking, the Renter gets full refund.",
  },
  {
    title:
      "I’m first timer renting the EQUIPMENT. What if I need help in the middle of the trip?",
    desc: "Haystackers provides 24/7 customer service. You can call us anytime and we will be glad to help you.",
  },
];

export const faqBillingAndCancellations = [
  {
    title: "How much does Haystackers charge?",
    desc: "From the rental revenue Haystackers charges 15% from the owner and 3.5% towards credit card processing.",
  },
  {
    title: "Does Haystackers charge commission on Overages also?",
    desc: "Yes;",
  },
  {
    title: "Does Haystackers has any credit card transaction fee?",
    desc: "Yes 3.5%",
  },
  {
    title: "When do I get paid by Haystackers?",
    desc: "As soon as EQUIPMENT is picked up by renter and updated on the platform/app; Haystackers will process payments to Owner.",
  },
  {
    title: "How does your cancellation and refund process work",
    descs: [
      "Flexible",
      "If Cancelled within 24 hours from Time of Booking  - Full Refund Minus 3.5% Credit Card Transaction fee",
      "If cancelled more than 2 days from rental start date- 100% refund Minus 3.5% Credit Card Transaction fee.",
      "If Cancelled with less than 2 days from rental start date- 25% penalty Minus 3.5% Credit Card Transaction fee.",
      "All bookings will have 24 hours from the time of booking to cancel without penalties or deductions. This is irrespective of EQUIPMENT’s type of Cancellation policy.  We call it “Change of plans”. We would like to keep Renter’s at ease while they plan vacations.",
    ],
  },
];

export const cookieName = "haystackerAuthToken";

export const RENTAL_API_TYPE = {
  RENTAL: 2,
  OWNER: 1,
};

export const CART_DELV_TYPE = {
  DELIVERY: 1,
  PICKUP: 0,
};

export const BOOKING_TYPES = {
  MANUAL: 1,
  INSTABOOK: 2,
};

export const BOOKING_STATUS: any = {
  PENDING: 1,
  requested: 1,

  PAYMENT_PENDING: 2,

  CONFIRMED: 3,
  confirmed: 3,

  REJECTED: 4,
  CANCELLED: 6,
  cancelled: 4,

  RETURNED: 7,
  completed: 7,

  SUGGEST_DATES: 5,
  STARTED: 9,
};

export const BOOKING_STATUS_TEXT: any = {
  PENDING: "Pending",

  PAYMENT_PENDING: "Payment Pending",

  CONFIRMED: "Confirmed",

  REJECTED: "Cancelled",
  CANCELLED: "Cancelled",

  RETURNED: "Returned",

  SUGGEST_DATES: 5,
  STARTED: 9,
  9: "DELIVERED",
};

export const LISTING_TYPE = {
  TRACTOR: 1,
  ATTACHMENT: 2,
};

export const LISTING_STATUS: any = {
  1: "Pending",
  PENDING: 1,
  2: "Under Review",
  3: "Published",
  UNDER_REVIEW: 2,
  REJECTED: 4,
  APPROVED: 3,
};

export const BOOKING_DOC_TYPE = {
  FORM: 1,
  IMAGES: 2,
  OTHERS: 3,
};

export const BOOKING_STAGE = {
  DEPARTURE: 1,
  RETURN: 2,
};

export const ADDRESS_TYPE = {
  LISTING: 1,
  DELIVERY: 2,
};

export const ALLLOWED_ZIP_COUNTRIES = ["US"];

export const REGISTRATION_TYPES = {
  EMAIL: 1,
  GOOGLE: 2,
  FACEBOOK: 3,
  APPLE: 4,
};

export const SOCIAL_MEDIA_LINKS = {
  LINKEDIN: "https://www.linkedin.com/company/haystackers-inc/",
  TWITTER: "https://twitter.com/TheHaystacker05",
  FACEBOOK: "https://www.facebook.com/haystackersinc",
  INSTAGRAM: "https://instagram.com/haystackersinc",
};

export const APP_DOCS = {
  TC: "Haystackers T&C.pdf",
  PP: "Haystackers Privacy Policy and CA Privacy Policy.pdf",
};

export const OTP_TYPE = {
  EMAIL: 1,
  MOBILE: 2,
};

export const DEVICE_TYPE = 1; //WEB

export const NOTIFICATION_TYPE = {
  NEW_BOOKING_REQUEST: 1,
  1: "NEW_BOOKING_REQUEST",
  BOOKING_ACCEPTED: 2,
  2: "BOOKING_ACCEPTED",
  BOOKING_REJECTED: 3,
  3: "BOOKING_REJECTED",
  BOOKING_DATE_SUGGESTED: 4,
  4: "BOOKING_DATE_SUGGESTED",
  WELCOME_MESSAGE: 5,
  5: "WELCOME_MESSAGE",
  NEW_LISTING_UNDER_REVIEW: 6,
  6: "NEW_LISTING_UNDER_REVIEW",
  NEW_LISTING_APPROVED: 7,
  7: "NEW_LISTING_APPROVED",
  NEW_LISTING_DECLINED: 8,
  8: "NEW_LISTING_DECLINED",
};

export const YES_NO_TYPES = {
  YES: 1,
  NO: 0,
};
